import { graphql, StaticQuery } from "gatsby"
import React, { Component } from "react"

import TechButton from "./widgets/TechButton"

import * as techStyles from "../styles/techStack.module.css"

class TechStack extends Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query TechStackQuery {
            dataJson(title: { eq: "TechStack" }) {
              techs {
                name
                url
                img {
                  childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
        `}
        render={data => (
          <React.Fragment>
            <div
              className="container"
              data-sal="slide-up"
              data-sal-delay="300"
              data-sal-easing="ease"
            >
              <div className={techStyles.divider}></div>
              <div className={techStyles.title}>
                TECH STACK
                <div className={techStyles.desc}>
                  &lt;LANGUAGES & FRAMEWORKS/&gt;
                </div>
              </div>
              <div className={`row ${techStyles.row}`}>
                {data.dataJson.techs.map(tech => (
                  <TechButton
                    key={tech.name}
                    url={tech.url}
                    fluid={tech.img.childImageSharp.fluid}
                    name={tech.name}
                  />
                ))}
              </div>
            </div>
          </React.Fragment>
        )}
      />
    )
  }
}

export default TechStack
